import axios from 'axios';
import { signOut } from 'firebase/auth';
import { auth } from './firebaseConfig';
import api from './api';

// Flag en sessionStorage para que Login muestre el aviso tras el redirect
// (el store se resetea al cerrar sesión, así que una alerta del store se perdería)
export const SESSION_EXPIRED_KEY = 'amanda_session_expired';

let handlingExpiredSession = false;

/**
 * Interceptor global de axios: cuando el backend responde 401 con el marcador
 * TOKEN_INVALID (token expirado/revocado/inválido en verifyToken), se cierra la
 * sesión de Firebase (onAuthStateChanged resetea el store) y se redirige a
 * /login con un aviso de "vuelve a iniciar sesión".
 *
 * OJO: solo reacciona al marcador TOKEN_INVALID. Otros 401 (p. ej. "Bad Rol"
 * de permisos) NO cierran la sesión.
 */
const onResponseError = async (error) => {
  const status = error.response?.status;
  const code = error.response?.data?.response?.code;

  if (status === 401 && code === 'TOKEN_INVALID' && !handlingExpiredSession) {
    handlingExpiredSession = true;
    try {
      sessionStorage.setItem(SESSION_EXPIRED_KEY, '1');
      await signOut(auth);
    } catch (signOutErr) {
      console.error('Error cerrando sesión expirada:', signOutErr);
    } finally {
      window.location.assign('/login');
    }
  }

  return Promise.reject(error);
};

export const setupAxiosInterceptors = () => {
  // Se registra tanto en el axios global (por si queda alguna llamada directa)
  // como en la instancia central `api`.
  axios.interceptors.response.use((response) => response, onResponseError);
  api.interceptors.response.use((response) => response, onResponseError);
};
